
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M161.1 323.2s.1 0 0 0h265.7c6.5 0 12.3-4.3 14.1-10.6l58.6-205.1c1.3-4.4.4-9.2-2.4-12.8-2.8-3.7-7.1-5.8-11.7-5.8h-358l-10.5-47.1c-1.5-6.7-7.4-11.5-14.3-11.5h-88C6.6 30.3 0 36.8 0 44.9s6.6 14.6 14.6 14.6h76.1c1.9 8.4 50.1 225.5 52.9 238-15.6 6.8-26.5 22.3-26.5 40.3 0 24.2 19.7 43.9 43.9 43.9h265.6c8.1 0 14.6-6.6 14.6-14.6 0-8.1-6.6-14.6-14.6-14.6H161.1c-8.1 0-14.6-6.6-14.6-14.6 0-8.1 6.5-14.6 14.6-14.7zm304.8-205L415.7 294H172.9l-39.1-175.8h332.1zM146.5 425.8c0 24.2 19.7 43.9 43.9 43.9s43.9-19.7 43.9-43.9-19.7-43.9-43.9-43.9-43.9 19.7-43.9 43.9zm43.9-14.7c8.1 0 14.6 6.6 14.6 14.6 0 8.1-6.6 14.6-14.6 14.6s-14.6-6.6-14.6-14.6 6.6-14.6 14.6-14.6zm163.1 14.7c0 24.2 19.7 43.9 43.9 43.9s43.9-19.7 43.9-43.9-19.7-43.9-43.9-43.9c-24.2-.1-43.9 19.7-43.9 43.9zm44-14.7c8.1 0 14.6 6.6 14.6 14.6 0 8.1-6.6 14.6-14.6 14.6-8.1 0-14.6-6.6-14.6-14.6-.1-8 6.5-14.6 14.6-14.6z"}})])
          )
        }
      }
    